import { VBox } from "@/components-v2/Box";
import { useTranslation } from "@/stores/RootStoreContext";
import { Markdown } from "@/text/Markdown";
import { observer } from "mobx-react";

export const NoticeToGmPanel = observer(() => {
  const { t } = useTranslation();
  return (
    <VBox>
      <Markdown value={t("dbot.boardmeeting.notice-to-gm-item-description")} />
    </VBox>
  );
});
